(() => {

  const page =
    document.querySelector(
      '[data-pnmp-page]'
    );

  if (!page) return;


  const esc = value =>
    String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');


  const slug =
    new URLSearchParams(
      window.location.search
    ).get('slug');


  const loading =
    page.querySelector(
      '[data-pnmp-loading]'
    );


  const error =
    page.querySelector(
      '[data-pnmp-error]'
    );


  const content =
    page.querySelector(
      '[data-pnmp-content]'
    );


  function formatTime(value) {

    const date =
      new Date(value);


    return new Intl.DateTimeFormat(
      undefined,
      {
        weekday:'short',
        day:'numeric',
        month:'short',
        hour:'numeric',
        minute:'2-digit'
      }
    ).format(date);

  }


  function renderTags(
    selector,
    values
  ) {

    const element =
      page.querySelector(selector);


    if (!element) return;


    element.innerHTML =
      Array.isArray(values) &&
      values.length
        ? values
            .map(
              item => `
                <span>
                  ${esc(item)}
                </span>
              `
            )
            .join('')
        : '<span>Not added yet</span>';

  }


  function showError() {

    loading.hidden =
      true;

    content.hidden =
      true;

    error.hidden =
      false;

  }


  /* PN5A_DYNAMIC_DURATION_BOOKING */

  let activeSessionMinutes =
    15;


  function cleanAvailability(
    values
  ) {

    return (
      Array.isArray(values)
        ? values
        : []
    )
      .filter(
        slot =>
          slot &&
          slot.id &&
          slot.starts_at &&
          slot.ends_at
      )
      .sort(
        (a, b) =>
          new Date(
            a.starts_at
          ).getTime()
          -
          new Date(
            b.starts_at
          ).getTime()
      );

  }


  function buildBookableSlots(
    values,
    minutes
  ) {

    const atomicSlots =
      cleanAvailability(
        values
      );


    /*
     * QUICK SESSION
     *
     * Every available 15-minute atomic slot
     * is bookable.
     */
    if (
      Number(minutes) ===
      15
    ) {

      return atomicSlots.map(
        slot => ({
          ...slot,
          duration_minutes:15
        })
      );

    }


    /*
     * DEEP DIVE
     *
     * A 30-minute session requires TWO
     * consecutive available 15-minute slots.
     *
     * Valid pairs are consumed together:
     *
     * 3:00 + 3:15 -> show 3:00
     * 3:30 + 3:45 -> show 3:30
     *
     * Therefore the visible list moves in
     * proper 30-minute session units.
     */
    const result =
      [];


    let index =
      0;


    while (
      index <
      atomicSlots.length - 1
    ) {

      const first =
        atomicSlots[index];

      const second =
        atomicSlots[index + 1];


      const firstEnd =
        new Date(
          first.ends_at
        ).getTime();


      const secondStart =
        new Date(
          second.starts_at
        ).getTime();


      const sameBlock =
        String(
          first.availability_block_id
          || ''
        )
        ===
        String(
          second.availability_block_id
          || ''
        );


      const consecutive =
        firstEnd ===
        secondStart;


      if (
        sameBlock &&
        consecutive
      ) {

        result.push({
          ...first,
          duration_minutes:30,
          session_ends_at:
            second.ends_at
        });


        index += 2;

      }
      else {

        index += 1;

      }

    }


    return result;

  }


  function syncDurationCards() {

    page
      .querySelectorAll(
        '[data-pnmp-duration]'
      )
      .forEach(
        card => {

          const selected =
            Number(
              card.dataset
                .pnmpDuration
            )
            ===
            activeSessionMinutes;


          card.classList.toggle(
            'is-selected',
            selected
          );


          card.setAttribute(
            'aria-pressed',
            selected
              ? 'true'
              : 'false'
          );

        }
      );

  }


  function bindDurationCards(
    profile
  ) {

    page
      .querySelectorAll(
        '[data-pnmp-duration]'
      )
      .forEach(
        card => {

          if (
            card.dataset
              .pnmpDurationBound ===
            'true'
          ) {
            return;
          }


          card.dataset
            .pnmpDurationBound =
            'true';


          const choose =
            () => {

              const nextDuration =
                Number(
                  card.dataset
                    .pnmpDuration
                );


              if (
                nextDuration !== 15 &&
                nextDuration !== 30
              ) {
                return;
              }


              activeSessionMinutes =
                nextDuration;


              /*
               * Re-render availability immediately
               * when session type changes.
               */
              render(
                profile
              );

            };


          card.addEventListener(
            'click',
            choose
          );


          card.addEventListener(
            'keydown',
            event => {

              if (
                event.key === 'Enter'
                ||
                event.key === ' '
              ) {

                event.preventDefault();

                choose();

              }

            }
          );

        }
      );


    syncDurationCards();

  }


  function render(profile) {

    loading.hidden =
      true;

    error.hidden =
      true;

    content.hidden =
      false;


    const photo =
      page.querySelector(
        '[data-pnmp-photo]'
      );


    if (profile.photo_url) {

      photo.innerHTML = `
        <img
          src="${esc(profile.photo_url)}"
          alt="${esc(profile.display_name)}"
        >
      `;

    }

    else {

      photo.textContent =
        String(
          profile.display_name || 'M'
        )
          .charAt(0)
          .toUpperCase();

    }


    page.querySelector(
      '[data-pnmp-name]'
    ).textContent =
      profile.display_name || 'Mentor';


    const collegeElement =
      page.querySelector(
        '[data-pnmp-college]'
      );


    if (collegeElement) {

      collegeElement.textContent =
        profile.college_name ||
        'N/A';

    }


    const locationWrap =
      page.querySelector(
        '[data-pnmp-location-wrap]'
      );

    const locationText =
      page.querySelector(
        '[data-pnmp-location]'
      );

    if (
      locationWrap &&
      locationText
    ) {

      if (profile.location_name) {
        locationText.textContent =
          profile.location_name;
        locationWrap.hidden =
          false;
      }

      else {
        locationText.textContent = '';
        locationWrap.hidden =
          true;
      }

    }


    const locationElement =
      page.querySelector(
        '[data-pnmp-location]'
      );


    if (locationElement) {

      locationElement.textContent =
        profile.location_name ||
        'N/A';

    }


    const programElement =
      page.querySelector(
        '[data-pnmp-program]'
      );


    if (programElement) {

      programElement.textContent =
        profile.program_name ||
        'Program not added';

    }


    const yearElement =
      page.querySelector(
        '[data-pnmp-year]'
      );


    if (yearElement) {

      yearElement.textContent =
        profile.graduation_year
          ? String(
              profile.graduation_year
            )
          : 'N/A';

    }


    page.querySelector(
      '[data-pnmp-bio]'
    ).textContent =
      profile.bio || '';


    const educationCollege =
      page.querySelector(
        '[data-pnmp-education-college]'
      );

    if (educationCollege) {
      educationCollege.textContent =
        profile.college_name ||
        'Not added';
    }


    const educationProgram =
      page.querySelector(
        '[data-pnmp-education-program]'
      );

    if (educationProgram) {
      educationProgram.textContent =
        profile.program_name ||
        'Not added';
    }


    const educationYear =
      page.querySelector(
        '[data-pnmp-education-year]'
      );

    if (educationYear) {
      educationYear.textContent =
        profile.graduation_year ||
        'Not added';
    }


    page.querySelector(
      '[data-pnmp-rating]'
    ).textContent =
      Number(profile.rating || 0)
        ? `${Number(profile.rating).toFixed(1)} ★`
        : 'New';


    page.querySelector(
      '[data-pnmp-sessions]'
    ).textContent =
      Number(
        profile.sessions_completed || 0
      );


    renderTags(
      '[data-pnmp-expertise]',
      profile.expertise
    );


    renderTags(
      '[data-pnmp-languages]',
      profile.languages
    );


    const slots =
      buildBookableSlots(
        profile.availability,
        activeSessionMinutes
      );


    const nextNode =
      page.querySelector(
        '[data-pnmp-next]'
      );


    if (nextNode) {

      nextNode.textContent =
        slots.length
          ? formatTime(
              slots[0].starts_at
            )
          : 'N/A';

    }


    const availability =
      page.querySelector(
        '[data-pnmp-availability]'
      );


    const bookingButton =
      page.querySelector(
        '[data-pnmp-book]'
      );


    const bookingMessage =
      page.querySelector(
        '[data-pnmp-book-message]'
      );


    if (!availability) {
      return;
    }


    availability.innerHTML =
      slots.length
        ? slots
            .slice(
              0,
              48
            )
            .map(
              slot => `
                <button
                  type="button"
                  class="pnmp-availability__slot"
                  data-pnmp-slot="${esc(
                    slot.id
                  )}"
                  aria-pressed="false"
                >
                  ${esc(
                    formatTime(
                      slot.starts_at
                    )
                  )}
                </button>
              `
            )
            .join('')
        : `
          <p>
            No complete ${activeSessionMinutes}-minute sessions available.
          </p>
        `;


    if (bookingButton) {

      bookingButton.dataset
        .selectedSlot =
        '';

      bookingButton.dataset
        .bookingBusy =
        'false';

      bookingButton.disabled =
        true;

      bookingButton.textContent =
        slots.length
          ? 'Select a time first →'
          : 'No slots available';

    }


    if (bookingMessage) {

      bookingMessage.textContent =
        slots.length
          ? `${activeSessionMinutes}-minute session selected. Choose a time.`
          : `No complete ${activeSessionMinutes}-minute sessions are available right now.`;

    }


    /*
     * SLOT SELECTION
     */
    availability.onclick =
      event => {

        const slotButton =
          event.target.closest(
            '[data-pnmp-slot]'
          );


        if (
          !slotButton ||
          !availability.contains(
            slotButton
          )
        ) {
          return;
        }


        const slotId =
          slotButton.dataset
            .pnmpSlot;


        if (!slotId) {
          return;
        }


        availability
          .querySelectorAll(
            '[data-pnmp-slot]'
          )
          .forEach(
            button => {

              const selected =
                button ===
                slotButton;


              button.classList.toggle(
                'is-selected',
                selected
              );


              button.setAttribute(
                'aria-pressed',
                selected
                  ? 'true'
                  : 'false'
              );

            }
          );


        if (bookingButton) {

          bookingButton.dataset
            .selectedSlot =
            slotId;

          bookingButton.disabled =
            false;

          bookingButton.textContent =
            `Book ${activeSessionMinutes} min Session →`;

        }


        const selectedSlot =
          slots.find(
            slot =>
              slot.id ===
              slotId
          );


        if (
          bookingMessage &&
          selectedSlot
        ) {

          bookingMessage.textContent =
            `${activeSessionMinutes}-minute session · ${formatTime(
              selectedSlot.starts_at
            )}`;

        }

      };


    /*
     * BOOK SESSION
     */
    if (bookingButton) {

      bookingButton.onclick =
        async () => {

          const slotId =
            bookingButton.dataset
              .selectedSlot;


          if (!slotId) {
            return;
          }


          if (
            bookingButton.dataset
              .bookingBusy ===
            'true'
          ) {
            return;
          }


          try {

            const profile =
              await window.PeerNestDB
                .getMyProfile();


            /*
             * No profile means visitor is not
             * currently authenticated.
             */
            if (!profile) {

              const next =
                window.location.pathname
                +
                window.location.search
                +
                window.location.hash;


              window.location.assign(
                '/pages/login?next='
                +
                encodeURIComponent(
                  next
                )
              );

              return;

            }


            if (
              profile.account_status !==
              'active'
            ) {

              throw new Error(
                'Your PeerNest account is not active.'
              );

            }


            if (
              profile.role !==
              'student'
            ) {

              throw new Error(
                'Only student accounts can book mentor sessions.'
              );

            }


            bookingButton.dataset
              .bookingBusy =
              'true';

            bookingButton.disabled =
              true;

            bookingButton.textContent =
              'Booking…';


            if (bookingMessage) {

              bookingMessage.textContent =
                `Confirming your ${activeSessionMinutes}-minute session…`;

            }


            /*
             * PAYMENT PASS
             *
             * 1. Reserve booking + slot(s)
             * 2. Create Razorpay order
             * 3. Open Razorpay Checkout
             * 4. Verify payment server-side
             * 5. Redirect only after confirmed payment
             */


            const session =
              await window.PeerNestDB
                .getSession();


            if (
              !session?.access_token
            ) {

              throw new Error(
                'Your session expired. Please sign in again.'
              );

            }


            const callPaymentFunction =
              async (
                functionName,
                body
              ) => {

                const response =
                  await fetch(
                    `https://tnlkoibetblgiovgkufs.supabase.co/functions/v1/${functionName}`,
                    {
                      method:'POST',

                      headers:{
                        Authorization:
                          `Bearer ${session.access_token}`,

                        'Content-Type':
                          'application/json'
                      },

                      body:
                        JSON.stringify(
                          body
                        )
                    }
                  );


                const payload =
                  await response
                    .json()
                    .catch(
                      () => ({})
                    );


                if (!response.ok) {

                  throw new Error(
                    payload?.error
                    ||
                    `Payment service failed (${response.status}).`
                  );

                }


                return payload;

              };


            /*
             * If Razorpay was closed without payment,
             * reuse the same still-valid reservation
             * when the button is clicked again.
             */
            let result = null;


            const savedPaymentId =
              bookingButton.dataset
                .pendingPaymentId;

            const savedBookingId =
              bookingButton.dataset
                .pendingBookingId;

            const savedSlotId =
              bookingButton.dataset
                .pendingSlotId;

            const savedExpiresAt =
              bookingButton.dataset
                .pendingExpiresAt;


            const savedDuration =
              Number(
                bookingButton.dataset
                  .pendingDuration
              );


            const savedReservationExists =
              savedPaymentId
              &&
              savedBookingId
              &&
              savedExpiresAt
              &&
              new Date(
                savedExpiresAt
              ).getTime() >
                Date.now();


            const savedReservationIsValid =
              savedReservationExists
              &&
              savedDuration ===
                Number(
                  activeSessionMinutes
                )
              &&
              savedSlotId ===
                String(slotId);


            /*
             * Duration changed while an unpaid reservation
             * is still active.
             *
             * Release the old held slot/payment first.
             */
            if (
              savedReservationExists
              &&
              !savedReservationIsValid
            ) {

              await window.PeerNestDB
                .request(
                  'rpc/pn_pay_cancel_mentor_reservation',
                  '',
                  {
                    method:'POST',

                    body:{
                      p_payment_id:
                        savedPaymentId
                    }
                  }
                );


              delete bookingButton
                .dataset
                .pendingPaymentId;

              delete bookingButton
                .dataset
                .pendingBookingId;

              delete bookingButton
                .dataset
                .pendingExpiresAt;

              delete bookingButton
                .dataset
                .pendingDuration;

              delete bookingButton
                .dataset
                .pendingSlotId;

            }


            if (
              savedReservationIsValid
            ) {

              result = {
                payment_id:
                  savedPaymentId,

                booking_id:
                  savedBookingId,

                expires_at:
                  savedExpiresAt,

                duration_minutes:
                  savedDuration
              };

            }
            else {

              result =
                await window.PeerNestDB
                  .request(
                    'rpc/pn_pay_reserve_mentor_booking',
                    '',
                    {
                      method:'POST',

                      body:{
                        p_slot_id:
                          slotId,

                        p_duration_minutes:
                          activeSessionMinutes,

                        p_student_notes:
                          null
                      }
                    }
                  );


              if (
                !result ||
                !result.booking_id ||
                !result.payment_id
              ) {

                throw new Error(
                  'Checkout reservation could not be created.'
                );

              }


              bookingButton.dataset
                .pendingPaymentId =
                  result.payment_id;

              bookingButton.dataset
                .pendingBookingId =
                  result.booking_id;

              bookingButton.dataset
                .pendingSlotId =
                  String(slotId);

              bookingButton.dataset
                .pendingExpiresAt =
                  result.expires_at;


              bookingButton.dataset
                .pendingDuration =
                  String(
                    result.duration_minutes
                    ||
                    activeSessionMinutes
                  );

            }


            bookingButton.textContent =
              'Preparing payment…';


            if (bookingMessage) {

              bookingMessage.textContent =
                'Your session is reserved for 15 minutes. Preparing secure payment…';

            }


            /*
             * CREATE RAZORPAY ORDER
             */
            const order =
              await callPaymentFunction(
                'razorpay-create-order',
                {
                  payment_id:
                    result.payment_id
                }
              );


            if (
              !order?.razorpay_key_id ||
              !order?.razorpay_order_id ||
              !order?.amount ||
              !order?.currency
            ) {

              throw new Error(
                'Razorpay checkout could not be prepared.'
              );

            }


            /*
             * LOAD RAZORPAY CHECKOUT
             */
            if (!window.Razorpay) {

              await new Promise(
                (
                  resolve,
                  reject
                ) => {

                  const source =
                    'https://checkout.razorpay.com/v1/checkout.js';


                  const existing =
                    document.querySelector(
                      `script[src="${source}"]`
                    );


                  if (existing) {

                    if (window.Razorpay) {

                      resolve();
                      return;

                    }


                    existing.addEventListener(
                      'load',
                      resolve,
                      {
                        once:true
                      }
                    );


                    existing.addEventListener(
                      'error',
                      () => {

                        reject(
                          new Error(
                            'Razorpay checkout could not be loaded.'
                          )
                        );

                      },
                      {
                        once:true
                      }
                    );


                    return;

                  }


                  const script =
                    document.createElement(
                      'script'
                    );


                  script.src =
                    source;

                  script.async =
                    true;


                  script.onload =
                    () => resolve();


                  script.onerror =
                    () => {

                      reject(
                        new Error(
                          'Razorpay checkout could not be loaded.'
                        )
                      );

                    };


                  document.head
                    .appendChild(
                      script
                    );

                }
              );

            }


            if (!window.Razorpay) {

              throw new Error(
                'Razorpay checkout is unavailable.'
              );

            }


            bookingButton.textContent =
              'Complete Payment';


            if (bookingMessage) {

              bookingMessage.textContent =
                'Complete payment to confirm your session.';

            }


            /*
             * OPEN RAZORPAY CHECKOUT
             */
            const verifiedPayment =
              await new Promise(
                (
                  resolve,
                  reject
                ) => {

                  let settled =
                    false;


                  let verificationStarted =
                    false;


                  const checkout =
                    new window.Razorpay({

                      key:
                        order.razorpay_key_id,

                      amount:
                        order.amount,

                      currency:
                        order.currency,

                      name:
                        'PeerNest',

                      description:
                        `${activeSessionMinutes}-minute mentor session`,

                      order_id:
                        order.razorpay_order_id,


                      handler:
                        async razorpayResponse => {

                          if (settled) {
                            return;
                          }


                          verificationStarted =
                            true;


                          try {

                            bookingButton.textContent =
                              'Verifying payment…';


                            if (bookingMessage) {

                              bookingMessage.textContent =
                                'Payment received. Confirming your session…';

                            }


                            const verified =
                              await callPaymentFunction(
                                'razorpay-verify-payment',
                                {
                                  payment_id:
                                    result.payment_id,

                                  razorpay_order_id:
                                    razorpayResponse
                                      .razorpay_order_id,

                                  razorpay_payment_id:
                                    razorpayResponse
                                      .razorpay_payment_id,

                                  razorpay_signature:
                                    razorpayResponse
                                      .razorpay_signature
                                }
                              );


                            if (
                              verified?.requires_refund ===
                                true
                              ||
                              verified?.fulfilled !==
                                true
                            ) {

                              delete bookingButton
                                .dataset
                                .pendingPaymentId;

                              delete bookingButton
                                .dataset
                                .pendingBookingId;

                              delete bookingButton
                                .dataset
                                .pendingExpiresAt;

                              delete bookingButton
                                .dataset
                                .pendingSlotId;


                              throw new Error(
                                'Payment was received, but the session could not be confirmed. Do not pay again. Please contact PeerNest support.'
                              );

                            }


                            settled =
                              true;


                            resolve(
                              verified
                            );

                          }
                          catch (error) {

                            settled =
                              true;

                            reject(
                              error
                            );

                          }

                        },


                      modal:{

                        ondismiss:
                          () => {

                            if (
                              settled
                              ||
                              verificationStarted
                            ) {
                              return;
                            }


                            settled =
                              true;


                            reject(
                              new Error(
                                'Payment was not completed. Click Book Session again to retry before your reservation expires.'
                              )
                            );

                          }

                      },


                      theme:{
                        color:
                          '#5B5FFB'
                      }

                    });


                  checkout.on(
                    'payment.failed',
                    response => {

                      if (
                        settled
                        ||
                        verificationStarted
                      ) {
                        return;
                      }


                      settled =
                        true;


                      reject(
                        new Error(
                          response?.error
                            ?.description
                          ||
                          'Payment failed. You can retry before your reservation expires.'
                        )
                      );

                    }
                  );


                  checkout.open();

                }
              );


            if (
              !verifiedPayment?.ok
            ) {

              throw new Error(
                'Payment verification failed.'
              );

            }


            delete bookingButton
              .dataset
              .pendingPaymentId;

            delete bookingButton
              .dataset
              .pendingBookingId;

            delete bookingButton
              .dataset
              .pendingExpiresAt;

            delete bookingButton
              .dataset
              .pendingSlotId;


            bookingButton.textContent =
              'Paid ✓';


            if (bookingMessage) {

              bookingMessage.textContent =
                'Payment verified. Session confirmed. Opening My Bookings…';

            }


            /*
             * Payment verified ->
             * Student Dashboard / My Bookings
             */
            window.location.assign(
              '/pages/student-dashboard?booking='
              +
              encodeURIComponent(
                result.booking_id
              )
              +
              '#bookings'
            );

          }
          catch (error) {

            console.error(
              '[PeerNest] Book Session:',
              error
            );


            bookingButton.dataset
              .bookingBusy =
              'false';

            bookingButton.disabled =
              false;

            bookingButton.textContent =
              `Book ${activeSessionMinutes} min Session →`;


            if (bookingMessage) {

              bookingMessage.textContent =
                error?.message
                ||
                'Could not book this session. Please choose another time.';

            }

          }

        };

    }


    bindDurationCards(
      profile
    );

  }


  async function load() {

    if (!slug) {
      showError();
      return;
    }


    try {

      const profile =
        await window.PeerNestDB
          .getPublicMentorBySlug(
            slug
          );


      if (
        !profile ||
        !profile.id
      ) {

        showError();
        return;

      }


      /* PN5A_REAL_AVAILABILITY_ROWS */

      const realAvailability =
        await window.PeerNestDB
          .request(
            'availability_slots',
            [
              'select=id,availability_block_id,starts_at,ends_at,status',
              `mentor_id=eq.${encodeURIComponent(profile.id)}`,
              'status=eq.available',
              `starts_at=gt.${encodeURIComponent(
                new Date().toISOString()
              )}`,
              'order=starts_at.asc',
              'limit=48'
            ].join('&')
          );


      profile.availability =
        Array.isArray(
          realAvailability
        )
          ? realAvailability
          : [];


      render(profile);

    }

    catch (err) {

      console.error(
        '[PeerNest] Public mentor profile:',
        err
      );


      showError();

    }

  }


  if (window.PeerNestDB) {

    load();

  }


  /* PN_REFRESH_AVAILABILITY_ON_PAGESHOW_V2
   *
   * Browsers may restore this page from back-forward cache.
   * Always refetch availability when a cached page is restored.
   */
  window.addEventListener(
    'pageshow',
    event => {

      if (
        event.persisted
        &&
        window.PeerNestDB
      ) {

        load();

      }

    }
  );


  if (!window.PeerNestDB) {

    document.addEventListener(
      'peernest:supabase-ready',
      load,
      {
        once:true
      }
    );

  }

})();

/* PNMP CONNECT JUMP JS START */

(function () {

  function initConnectButton() {

    const button = document.querySelector(
      '[data-pnmp-connect-jump]'
    );

    if (!button) return;

    button.addEventListener('click', event => {

      event.preventDefault();

      // Handle the click directly instead of depending
      // on it bubbling to the document listener.
      event.stopPropagation();

      const target =
        document.getElementById('sessions') ||
        document.querySelector('.pnmp-book');

      if (!target) return;

      const navbar =
        document.querySelector('.pn-navbar');

      const navbarHeight = navbar
        ? navbar.getBoundingClientRect().height
        : 0;

      const targetTop =
        target.getBoundingClientRect().top
        + window.scrollY
        - navbarHeight
        - 18;

      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: 'smooth'
      });

    }, { capture: true });

  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initConnectButton,
      { once: true }
    );
  } else {
    initConnectButton();
  }

})();

/* PNMP CONNECT JUMP JS END */
